import React from 'react';

interface ICalendarIconProps {
	size?: string;
	fill?: string;
}

export const CalendarIcon = ({ size = '24', fill }: ICalendarIconProps) => (
	<svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none">
		<path
			d="M20.1429 4.5L3.85714 4.5C3.10761 4.5 2.5 5.08547 2.5 5.80769L2.5 20.1923C2.5 20.9145 3.10761 21.5 3.85714 21.5L20.1429 21.5C20.8924 21.5 21.5 20.9145 21.5 20.1923L21.5 5.80769C21.5 5.08547 20.8924 4.5 20.1429 4.5Z"
			stroke={fill || '#3D3D3D'}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path d="M3 10.5L21 10.5" stroke={fill || '#3D3D3D'} strokeLinecap="round" strokeLinejoin="round" />
		<path d="M7.5 6.66667L7.5 2" stroke={fill || '#3D3D3D'} strokeLinejoin="round" />
		<path d="M16.5 6.66667V2" stroke={fill || '#3D3D3D'} strokeLinejoin="round" />
	</svg>
);
